import { MakeCall } from 'ha/services/apiV2/createMakeCall';

import { PaymentPlanDetails } from './types';

export default (makeCall: MakeCall) => (
  paymentPlanToken: string,
): Promise<{ data: PaymentPlanDetails; status: number }> =>
  makeCall<PaymentPlanDetails>(
    'GET',
    `/api/v1/plans/pending/${paymentPlanToken}`,
  );
